export const SET_CATEGORIES = 'SET_CATEGORIES';

export const categoriesSettings = {
  isLoading: false,
  data: []
};
